import Immutable from 'immutable'

const Record = Immutable.Record({
  floatingCart: false,
  cartOpen: false,
  modalPickerOpen: false,
  cartScroll: 0,
  cartId: null,
  periodPickerOpen: false,
  checkingOut: false,
  currency: Immutable.Map(),
  translations: Immutable.Map(),
  company: Immutable.Map(),
  custom_fields: {},
  enabledFeatures: [],
  supportedFulfillmentTypes: [],
  locale: 'en',
  cartOverdue: false,
  firstTimeSelectable: undefined,
  defaultStartTime: undefined,
  defaultStopTime: undefined,
  readOnlyMode: false
})

const initialState = new Record()

export default function (state = initialState, action) {
  switch (action.type) {
    case 'CARTS_SET_PERIOD_SUCCESS':
    case 'CARTS_FETCH_SUCCESS':
    case 'CARTS_BOOK_SUCCESS':
    case 'CARTS_UPDATE_SUCCESS': {
      const { id } = action.payload.response.cart
      const data = action.payload.response.meta

      data.cartId = id
      localStorage.bqCartId = id

      return state.merge({
        cartId: id,
        company: data.company,
        currency: data.currency,
        custom_fields: data.custom_fields,
        enabledFeatures: data.features_enabled,
        translations: data.translations,
        supportedFulfillmentTypes: data.supported_fulfillment_types
      })
    }
    case 'LOCALE_SET':
      return state.merge({
        locale: action.payload.locale
      })
    case 'DEFAULT_TIMES_INITIALIZED':
      return state.merge(action.payload)
    case 'SET_CART_ID':
      return state.merge(action.payload)
    case 'SET_FLOATING_CART':
      return state.merge(action.payload)
    case 'TOGGLE_CART':
      return state.merge(action.payload)
    case 'TOGGLE_PICKER':
      return state.merge(action.payload)
    case 'TOGGLE_PERIOD_PICKER':
      return state.merge(action.payload)
    case 'SET_CART_SCROLL':
      return state.merge(action.payload)
    case 'SET_CHECKING_OUT':
      return state.merge({ checkingOut: action.payload !== undefined ? action.payload : true })
    case 'SET_CART_OVERDUE':
      return state.merge({ cartOverdue: action.payload })
    case 'SET_READ_ONLY_MODE':
      return state.set('readOnlyMode', action.payload.read_only_mode)
    default:
      return state
  }
}
